import { render, staticRenderFns } from "./beautyContestScaning.vue?vue&type=template&id=009d5bb0&scoped=true&"
import script from "./beautyContestScaning.vue?vue&type=script&lang=ts&"
export * from "./beautyContestScaning.vue?vue&type=script&lang=ts&"
import style0 from "./beautyContestScaning.scss?vue&type=style&index=0&id=009d5bb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d5bb0",
  null
  
)

export default component.exports